import React, { useEffect, useMemo, useRef } from 'react';
import { getAnchor, scrollToHash } from 'framework/utils';
import { useLocation } from 'react-router-dom';
import { copyToClipboard } from 'framework/ui/clipboard';
import useFieldHelper from './fieldHelper';
import { LinkFieldProps } from './LinkField';

export const getAnchorRowStyle = (data: any, hash: string) => {
  return hash && `#${getAnchor(data.alias)}` === hash
    ? {
        sx: {
          backgroundColor: 'background.primary',
        },
      }
    : {};
};

const handleAnchorClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
  e.preventDefault();
  copyToClipboard(e.currentTarget.href);
};

const AnchorField = (props: LinkFieldProps) => {
  const { getValue } = useFieldHelper(props);
  const anchor = useMemo(() => getAnchor(getValue()), [getValue]);
  const anchorRef = useRef<HTMLAnchorElement>(null);
  const { hash } = useLocation();

  useEffect(() => {
    if (hash && anchorRef.current && anchorRef.current.getAttribute('href') === hash) {
      scrollToHash(anchorRef.current);
    }
  }, [hash]);

  return (
    <>
      <a href={`#${anchor}`} onClick={handleAnchorClick} id={`copy-${anchor}`} ref={anchorRef}>
        {getValue()}
      </a>
      <span id={anchor} className="invisible-anchor" />
    </>
  );
};

export default AnchorField;
